'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class IdentifiedUserModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'confirmed':
				return this.confirmed > 0 ? 'Yes' : 'No';
			case 'confirmed_date':
				return this.s('$filter')('u2date')(this.confirmed_date, 'dd/MM/y');
			case 'name':
				if(typeof(this.name) !== 'undefined' || typeof(this.lastname) !== 'undefined'){
					return this.name + ' ' + this.lastname;
				}
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}